import { render, staticRenderFns } from "./TopProdutos.vue?vue&type=template&id=44660d0a&scoped=true"
import script from "./TopProdutos.vue?vue&type=script&lang=js"
export * from "./TopProdutos.vue?vue&type=script&lang=js"
import style0 from "./TopProdutos.vue?vue&type=style&index=0&id=44660d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44660d0a",
  null
  
)

export default component.exports